import cn from 'classnames';
import { type DetailedHTMLProps, type HTMLAttributes, type ReactNode } from 'react';

import cls from './flex.module.scss';

export type FlexJustify = 'start' | 'center' | 'end' | 'between';
export type FlexAlign = 'start' | 'center' | 'end' | 'stretch';
export type FlexDirection = 'row' | 'column';
export type FlexGap = '2' | '4' | '8' | '12' | '16' | '20' | '24' | '28' | '32' | '60' | '64';
export type Mods = Record<string, boolean | string | undefined>;

const justifyClasses: Record<FlexJustify, string> = {
  start: cls.justifyStart,
  center: cls.justifyCenter,
  end: cls.justifyEnd,
  between: cls.justifyBetween,
};

const alignClasses: Record<FlexAlign, string> = {
  start: cls.alignStart,
  center: cls.alignCenter,
  end: cls.alignEnd,
  stretch: cls.alignStretch,
};

const directionClasses: Record<FlexDirection, string> = {
  row: cls.directionRow,
  column: cls.directionColumn,
};

const gapClasses: Record<FlexGap, string> = {
  2: cls.gap2,
  4: cls.gap4,
  8: cls.gap8,
  12: cls.gap12,
  16: cls.gap16,
  20: cls.gap20,
  24: cls.gap24,
  28: cls.gap28,
  32: cls.gap32,
  60: cls.gap60,
  64: cls.gap64,
};
type DivProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export type FlexProps = DivProps & {
  className?: string;
  children: ReactNode;
  justify?: FlexJustify;
  align?: FlexAlign;
  direction: FlexDirection;
  gap?: FlexGap;
  scroll?: boolean;
  max?: boolean;
  wrap?: boolean;
  mt?: number;
  mb?: number;
  ml?: number;
  pt?: number;
  pb?: number;
  pl?: number;
  pr?: number;
  p?: number;
  rounded?: number;
  maxw?: number;
};

export const Flex = (props: FlexProps) => {
  const {
    className,
    children,
    justify = 'start',
    align = 'center',
    direction = 'row',
    mt,
    mb,
    ml,
    pt,
    pb,
    pl,
    pr,
    p,
    maxw,
    rounded,
    gap,
    scroll,
    max = false,
    wrap = false,
  } = props;

  const classes = [
    className,
    justifyClasses[justify],
    alignClasses[align],
    directionClasses[direction],
    gap && gapClasses[gap],
    scroll && cls.scroll,
  ];

  const mods: Mods = {
    [cls.max]: Boolean(max),
    [cls.wrap]: wrap,
  };

  return (
    <div
      style={{
        marginTop: `${mt}px`,
        marginBottom: `${mb}px`,
        marginLeft: `${ml}px`,
        padding: `${p}px`,
        paddingTop: `${pt}px`,
        paddingBottom: `${pb}px`,
        paddingLeft: `${pl}`,
        paddingRight: `${pr}`,
        borderRadius: `${rounded}px`,
        maxWidth: `${maxw}px`,
        ...props.style,
      }}
      onClick={props.onClick}
      className={cn(cls.Flex, mods, classes, className)}
    >
      {children}
    </div>
  );
};
